module.exports = __webpack_public_path__ + "img/CatchView-dessin-584x584.daf13c4a.webp";